var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"confirmation-data-item"},[_c('div',{staticClass:"confirmation-data-item_name"},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"confirmation-data-item_value"},[_vm._v(_vm._s(_vm.filteredValue))])])
}
var staticRenderFns = []

export { render, staticRenderFns }